import { Link } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { cn } from '@/utils/cn';

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={cn('h-8 w-8', className)} aria-hidden>
      <defs>
        <linearGradient id="logo-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366f1" />
          <stop offset="1" stopColor="#a855f7" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#logo-gradient)" />
      <path
        d="M32 15v20m0 0l-9-9m9 9l9-9"
        stroke="#fff"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M19 45h26" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ withText = true }: { withText?: boolean }) {
  return (
    <Link to={ROUTES.home} className="flex items-center gap-2.5 focus-ring rounded-xl" aria-label="Instagram Media Downloader home">
      <LogoMark />
      {withText && (
        <span className="text-lg font-bold tracking-tight text-zinc-100">
          Insta<span className="text-gradient">gram</span>
        </span>
      )}
    </Link>
  );
}
